export const siteInfo = {
  name: '吃瓜网站线路一',
  slogan: '最新最全的吃瓜视频资源平台',
  subSlogan: '每日更新 · 海量资源 · 免费观看',
  intro: '吃瓜网站线路一是国内领先的吃瓜视频聚合平台，专注为吃瓜爱好者提供51吃瓜在线观看、吃瓜视频在线看等一站式服务。我们汇聚全网最新免费吃瓜视频资源，涵盖娱乐圈动态、社会热点事件、网红达人八卦等多元内容，黑料视频在线即时播放，每日持续更新，让你不错过任何一个精彩瓜料。无论你是资深吃瓜群众还是刚入坑的新手，这里都能满足你在线吃瓜的所有需求。',
};

export const headerNav = [
  { label: '首页', href: '#hero' },
  { label: '最新动向', href: '#updates' },
  { label: '热搜榜单', href: '#ranking' },
  { label: '网友热评', href: '#comments' },
  { label: '焦点专题', href: '#carousel' },
  { label: '关于我们', href: '#about' },
  { label: '常见问题', href: '#faq' },
];

export const heroStats = [
  { label: '视频总量', value: '58,000+' },
  { label: '每日更新', value: '200+' },
  { label: '在线用户', value: '3.2万' },
];

export const contactInfo = {
  description: '如果你有最新的瓜料线索、爆料投稿或合作咨询需求，欢迎通过以下方式联系我们。我们珍视每一条来自用户的真实信息，吃瓜网站线路一始终为真相发声。',
  email: 'tougao@chigua.example.com',
  wechat: 'chigua51line1',
};

export const aboutInfo = {
  title: '关于吃瓜网站线路一',
  paragraphs: [
    '吃瓜网站线路一创建于2020年，是国内最早一批专注于吃瓜文化传播的视频聚合平台。我们以「让每个人都能轻松吃瓜」为使命，通过技术手段聚合全网51吃瓜视频资源，为用户提供快捷、流畅的在线吃瓜体验。',
    '平台拥有独立的内容审核团队，所有展示的黑料视频与吃瓜视频均经过多重筛选，确保信息真实可靠。我们不仅提供吃瓜视频在线看服务，还建立了一套完整的内容标签体系，让用户可以根据自己的兴趣快速找到想看的瓜料。',
    '截至目前，吃瓜网站线路一已累计服务超过800万吃瓜用户，日均视频播放量突破500万次。未来我们将持续优化产品体验，拓展51吃瓜视频资源库，做你身边最懂吃瓜的互联网伙伴。',
  ],
};

export const topicTags = [
  { name: '娱乐圈大瓜', icon: 'ri-fire-line', count: '1.2万条', hot: true },
  { name: '网红翻车', icon: 'ri-emotion-sad-line', count: '8,600条', hot: true },
  { name: '明星恋情', icon: 'ri-heart-line', count: '9,300条', hot: false },
  { name: '社会热点', icon: 'ri-earth-line', count: '1.5万条', hot: true },
  { name: '综艺名场面', icon: 'ri-tv-line', count: '6,700条', hot: false },
  { name: '直播实录', icon: 'ri-live-line', count: '5,400条', hot: false },
  { name: '情感八卦', icon: 'ri-chat-smile-2-line', count: '7,800条', hot: false },
  { name: '行业潜规则', icon: 'ri-spy-line', count: '4,200条', hot: true },
  { name: '黑料实锤', icon: 'ri-hammer-line', count: '3,900条', hot: true },
];

export const rankingItems = [
  { rank: 1, title: '某顶流艺人深夜密会神秘女子全程跟拍', views: '128万', tag: '独家', trend: 'up' },
  { rank: 2, title: '知名主播直播翻车现场完整回放合集', views: '96万', tag: '热门', trend: 'up' },
  { rank: 3, title: '某综艺节目录制现场冲突内幕大揭秘', views: '83万', tag: '新瓜', trend: 'up' },
  { rank: 4, title: '一线女星私密朋友圈截图流出引热议', views: '71万', tag: '热议', trend: 'same' },
  { rank: 5, title: '知名企业家离婚案最新进展独家曝光', views: '65万', tag: '跟进', trend: 'down' },
  { rank: 6, title: '网红带货数据造假幕后产业链深度扒皮', views: '58万', tag: '深度', trend: 'up' },
  { rank: 7, title: '某品牌代言人解约风波背后真相调查', views: '52万', tag: '真相', trend: 'same' },
];

export const faqItems = [
  {
    q: '吃瓜网站线路一的视频需要付费观看吗？',
    a: '完全不需要！吃瓜网站线路一承诺所有51吃瓜在线观看内容均为免费，包括最新吃瓜视频和黑料视频在线播放。我们通过广告收入维持运营，用户无需支付任何费用即可畅享全部视频资源。',
  },
  {
    q: '平台每天更新多少条吃瓜视频？',
    a: '我们每天平均更新200条以上免费吃瓜视频，涵盖娱乐八卦、网红动态、社会事件等多个板块。更新频率在行业内处于领先水平，确保你每天都有新鲜瓜料可以看。',
  },
  {
    q: '如何搜索我想看的特定吃瓜视频？',
    a: '你可以使用网站顶部的搜索功能，输入关键词如明星名字、事件名称即可找到相关吃瓜视频在线看。我们还提供了话题标签（如#娱乐圈大瓜#、#黑料实锤#等）帮助你快速浏览感兴趣的内容。',
  },
  {
    q: '投稿爆料会被保护隐私吗？',
    a: '绝对会！我们高度重视投稿者的隐私安全。所有通过投稿渠道发来的信息，我们都会对提供者的身份信息进行严格加密处理，绝不向第三方透露任何个人信息。',
  },
  {
    q: '为什么有些视频加载比较慢？',
    a: '由于吃瓜网站线路一聚合了多个视频源，部分视频可能受到源站带宽影响出现加载延迟。我们建议在WiFi环境下观看高清内容，同时可以尝试切换线路获得更流畅的播放体验。',
  },
];

export const updatesItems = [
  { time: '12分钟前', content: '某选秀节目导师组内淘汰赛录制路透曝光，三位学员意外晋级引发争议', tag: '综艺' },
  { time: '28分钟前', content: '知名编剧发长文炮轰某平台数据造假，引发业内广泛讨论', tag: '行业' },
  { time: '1小时前', content: '某女星微博小号被扒出，日常内容与荧幕人设反差巨大', tag: '明星' },
  { time: '2小时前', content: '热门综艺录制现场突发状况，导演组紧急叫停拍摄', tag: '综艺' },
  { time: '3小时前', content: '某带货主播被曝虚假宣传，品牌方连夜发布声明切割关系', tag: '网红' },
  { time: '5小时前', content: '年度最受期待电影疑似换角，新主演路透照流出', tag: '影视' },
  { time: '7小时前', content: '某知名品牌代言人官宣解约，违约金数额成新瓜焦点', tag: '商业' },
  { time: '9小时前', content: '圈内人士爆料某综艺剧组内部矛盾，制作人已提交辞呈', tag: '内幕' },
  { time: '12小时前', content: '某社交平台大V被集体举报，账号涉嫌传播不实信息被限流', tag: '平台' },
];

export const commentItems = [
  {
    avatar: 'R',
    name: '吃瓜不嫌事大',
    time: '3小时前',
    content: '这个瓜我吃了三天了，越吃越香！吃瓜网站线路一的信息更新速度是真的快，比微博还早半小时，已经推荐给身边所有吃瓜朋友了。',
    likes: 256,
    tag: '铁杆瓜友',
  },
  {
    avatar: 'M',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '从去年开始就用这个站看吃瓜视频在线看了，资源全而且免费，不像有些平台动不动就要会员。51吃瓜视频资源库是真的强大，基本想看的瓜都能搜到。',
    likes: 189,
    tag: '老用户',
  },
  {
    avatar: 'L',
    name: '理性吃瓜群众',
    time: '8小时前',
    content: '难得有一个不瞎编乱造的吃瓜平台，每一条黑料视频在线播放前都有审核说明，真假分明。希望继续保持这种负责任的态度，做有良心的在线吃瓜平台。',
    likes: 142,
    tag: '新瓜友',
  },
];

export const appInfo = {
  description: '随时随地，吃瓜不停！下载吃瓜网站线路一移动客户端，享受更流畅的51吃瓜在线观看体验。支持iOS与Android双平台，安装即可获得专属推送提醒，重要瓜料不再错过。',
  features: ['极速加载，流量消耗更低', '独家推送，大瓜第一时间知晓', '夜间模式，深夜吃瓜不伤眼', '离线缓存，没有网络也能看'],
};

export const mediaItems = [
  { title: '某顶流深夜密会完整视频', duration: '15:28', views: '128万', tag: '独家', imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20entertainment%20media%20background%20with%20soft%20gradient%20coral%20and%20amber%20colors%2C%20modern%20digital%20video%20platform%20aesthetic%2C%20playful%20geometric%20shapes%20with%20smooth%20curves%2C%20clean%20minimal%20design%2C%20warm%20atmosphere%2C%20no%20text&width=800&height=450&seq=media-vid-01&orientation=landscape' },
  { title: '直播翻车名场面合集', duration: '08:42', views: '96万', tag: '热门', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20composition%20with%20peach%20and%20coral%20gradient%2C%20modern%20streaming%20platform%20aesthetic%20background%2C%20soft%20geometric%20shapes%20with%20flowing%20lines%2C%20energetic%20and%20playful%20design%2C%20clean%20minimal%20style%2C%20no%20text&width=800&height=450&seq=media-vid-02&orientation=landscape' },
  { title: '综艺冲突内幕全纪录', duration: '22:15', views: '83万', tag: '深度', imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20gradient%20abstract%20art%20with%20warm%20amber%20and%20rose%20tones%2C%20television%20studio%20inspired%20geometric%20patterns%2C%20dramatic%20lighting%20effect%20with%20smooth%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=800&height=450&seq=media-vid-03&orientation=landscape' },
  { title: '网红道歉发布会现场实录', duration: '11:30', views: '67万', tag: '跟进', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20coral%20and%20peach%20abstract%20background%20with%20soft%20overlapping%20circles%2C%20modern%20press%20conference%20inspired%20design%20elements%2C%20smooth%20flowing%20gradients%2C%20professional%20media%20aesthetic%2C%20warm%20atmosphere%2C%20no%20text&width=800&height=450&seq=media-vid-04&orientation=landscape' },
];

export const featureItems = [
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '7×24小时全天候运营，重要瓜料最快5分钟内上线，让你永远快人一步吃到第一手新鲜瓜。' },
  { icon: 'ri-shield-check-line', title: '多重核验', desc: '每条黑料视频上线前经过三级审核流程，标注信息来源与可信度评级，让你吃得放心。' },
  { icon: 'ri-stack-line', title: '海量资源', desc: '聚合全网51吃瓜视频资源超过58000条，涵盖娱乐、网红、社会等12大品类，总能找到你想看的。' },
  { icon: 'ri-smartphone-line', title: '多端适配', desc: '支持PC、平板、手机全终端无缝切换，移动端专属优化确保免费吃瓜视频随时随地流畅播放。' },
];

export const cardItems = [
  { title: '揭秘娱乐圈潜规则：从选角到资源分配的完整产业链', imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20illustration%20with%20warm%20coral%20and%20peach%20tones%2C%20abstract%20geometric%20composition%20representing%20entertainment%20industry%20investigation%2C%20soft%20gradient%20background%20with%20dramatic%20shapes%2C%20clean%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text&width=800&height=600&seq=card-img-01&orientation=landscape', desc: '深度调查娱乐圈内部运作机制，揭露选角过程中的灰色地带与资源分配的真实逻辑。', tag: '深度调查', date: '2026-07-29' },
  { title: '2026上半年十大翻车网红事件回顾评析', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20design%20with%20coral%20pink%20and%20amber%20gradients%2C%20modern%20analysis%20visualization%20with%20overlapping%20translucent%20shapes%2C%20professional%20magazine%20layout%20aesthetic%2C%20clean%20minimal%20style%2C%20no%20text&width=800&height=600&seq=card-img-02&orientation=landscape', desc: '盘点今年上半年最具影响力的网红翻车事件，分析背后的原因与教训。', tag: '年度盘点', date: '2026-07-28' },
  { title: '从素人到顶流：某艺人十年星路背后的推手揭秘', imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20peach%20and%20rose%20abstract%20illustration%20with%20elegant%20flowing%20curves%2C%20modern%20portrait%20magazine%20cover%20inspired%20design%2C%20geometric%20patterns%20with%20gradient%20overlays%2C%20sophisticated%20editorial%20aesthetic%2C%20warm%20lighting%2C%20no%20text&width=800&height=600&seq=card-img-03&orientation=landscape', desc: '追溯一位知名艺人的成名之路，解析其背后经纪团队与资本运作的全过程。', tag: '人物特写', date: '2026-07-27' },
  { title: '社交平台算法如何影响吃瓜文化传播路径', imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20tech%20abstract%20design%20with%20warm%20coral%20and%20amber%20gradients%2C%20social%20media%20network%20inspired%20geometric%20patterns%2C%20flowing%20data%20visualization%20shapes%2C%20clean%20professional%20analysis%20style%2C%20warm%20atmosphere%2C%20no%20text&width=800&height=600&seq=card-img-04&orientation=landscape', desc: '技术视角分析抖音、微博等平台的推荐算法如何加速瓜料传播与舆论发酵。', tag: '行业观察', date: '2026-07-26' },
  { title: '独家对话：一位资深娱记的二十年吃瓜史', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20interview%20magazine%20illustration%20with%20coral%20and%20gold%20accents%2C%20sophisticated%20journalism%20aesthetic%20with%20layered%20textures%2C%20elegant%20geometric%20composition%2C%20professional%20editorial%20design%2C%20warm%20atmosphere%2C%20no%20text&width=800&height=600&seq=card-img-05&orientation=landscape', desc: '专访从业20年的娱乐记者，听他讲述那些年轰动一时的娱乐圈大事件幕后故事。', tag: '独家专访', date: '2026-07-25' },
  { title: '吃瓜经济学：一条八卦如何创造千万流量价值', imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20business%20abstract%20design%20with%20warm%20coral%20pink%20and%20gold%20gradients%2C%20financial%20data%20visualization%20inspired%20geometric%20shapes%2C%20flowing%20chart%20like%20patterns%2C%20professional%20analysis%20aesthetic%2C%20warm%20minimal%20style%2C%20no%20text&width=800&height=600&seq=card-img-06&orientation=landscape', desc: '从流量变现角度解析吃瓜视频产业链，揭示点击量背后的商业运作模式。', tag: '商业分析', date: '2026-07-24' },
];

export const indexItems = [
  { title: '娱乐圈情感专题', count: '2,380篇', icon: 'ri-heart-2-line' },
  { title: '艺人翻车合集', count: '1,850篇', icon: 'ri-error-warning-line' },
  { title: '综艺爆料专栏', count: '3,120篇', icon: 'ri-tv-2-line' },
  { title: '网红八卦周报', count: '2,760篇', icon: 'ri-user-smile-line' },
  { title: '影视圈内幕', count: '1,640篇', icon: 'ri-film-line' },
  { title: '品牌代言风云', count: '980篇', icon: 'ri-briefcase-line' },
  { title: '直播圈那些事', count: '2,150篇', icon: 'ri-live-line' },
  { title: '社会事件追踪', count: '1,420篇', icon: 'ri-global-line' },
  { title: '年度吃瓜年鉴', count: '560篇', icon: 'ri-book-open-line' },
];

export const carouselItems = [
  { title: '2026娱乐圈年中大考：谁在翻车谁在逆袭', desc: '盘点今年上半年娱乐圈最令人震惊的十大事件，从顶流塌房到新人爆红，带你回顾这不平凡的六个月。', imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20editorial%20magazine%20cover%20style%20illustration%20with%20warm%20coral%20pink%20and%20deep%20burgundy%20gradient%20tones%2C%20dramatic%20abstract%20composition%20with%20sweeping%20curves%20and%20layered%20textures%2C%20sophisticated%20investigative%20journalism%20aesthetic%2C%20rich%20contrast%20between%20light%20and%20dark%20areas%2C%20premium%20quality%20editorial%20design%2C%20warm%20dramatic%20atmosphere%2C%20no%20text&width=760&height=475&seq=carousel-01&orientation=landscape', tag: '重磅策划' },
  { title: '网红经济泡沫破裂始末：从月入百万到无人问津', desc: '深入剖析网红带货行业从巅峰到低谷的完整过程，揭示数据造假、信任危机与行业洗牌背后的真相。', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20investigative%20journalism%20illustration%20with%20coral%20and%20burgundy%20gradients%2C%20dramatic%20abstract%20shapes%20representing%20economic%20decline%20and%20transformation%2C%20layered%20textures%20with%20flowing%20lines%2C%20premium%20editorial%20aesthetic%2C%20sophisticated%20atmosphere%2C%20no%20text&width=760&height=475&seq=carousel-02&orientation=landscape', tag: '深度报道' },
  { title: '解密综艺节目剧本门：真人秀有多真', desc: '多位前综艺从业者匿名爆料，还原综艺节目从策划到录制过程中的剧本操作与冲突设计。', imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20design%20with%20warm%20amber%20and%20deep%20rose%20gradients%2C%20television%20studio%20inspired%20geometric%20composition%20with%20spotlight%20effects%2C%20layered%20translucent%20shapes%2C%20premium%20magazine%20quality%2C%20rich%20contrast%2C%20no%20text&width=760&height=475&seq=carousel-03&orientation=landscape', tag: '独家揭秘' },
  { title: '明星代言翻车全记录：那些年品牌踩过的坑', desc: '梳理近三年明星代言翻车典型案例，分析品牌方在代言人选择上的失误与危机公关得失。', imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20illustration%20with%20warm%20coral%20and%20gold%20gradient%20tones%2C%20abstract%20brand%20marketing%20inspired%20shapes%20with%20broken%20geometric%20patterns%2C%20dramatic%20composition%20with%20depth%2C%20sophisticated%20business%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text&width=760&height=475&seq=carousel-04&orientation=landscape', tag: '行业观察' },
  { title: '吃瓜文化十年变迁：从论坛时代到短视频狂欢', desc: '回顾中国互联网吃瓜文化的发展历程，从天涯论坛到微博再到抖音，看吃瓜方式的演变与升级。', imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20timeline%20illustration%20with%20coral%20pink%20and%20amber%20gradients%2C%20cultural%20evolution%20inspired%20flowing%20shapes%20representing%20digital%20transformation%2C%20layered%20geometric%20patterns%20with%20depth%2C%20sophisticated%20cultural%20magazine%20aesthetic%2C%20warm%20atmosphere%2C%20no%20text&width=760&height=475&seq=carousel-05&orientation=landscape', tag: '文化观察' },
];